<template>
    <div class="">
        <div class="status"
            :class="alignMessage"
        >
            <span v-if="showUser">{{ $trim(message.user.name, 35)  }}</span>
        </div>
        <div :class="[message.user.picture ? 'chat_msg_avatar' : 'chat_msg_avatar', align]">
            <span
                class="avatar avatar-sm rounded-circle"
                :class="[userType, align]"
            >
                <img alt="profile" :src="message.user.picture ? message.user.picture : '/img/profile.png'">
            </span>
            <span
                class="chat_msg_item"
                :class="[userType, pending ? 'chat_msg_item_pending' : '']"
            >
                <span class="d-flex">{{ message.content }}</span>
                <small v-if="pending" class="chat_msg_pending_label">{{ $t('chat.pending') }}</small>
                <ChatMessageUploadOpen
                    v-if="message.upload"
                    :model-value="message.upload"
                ></ChatMessageUploadOpen>
            </span>
        </div>
        <div
            class="status"
            :class="alignMessage"
        >
            <span v-if="showTime">{{ $moment(message.created_at).format('LL') }}</span>
        </div>
    </div>
</template>

<script>

import ChatMessageUploadOpen from './ChatMessageUploadOpen';

export default {
    emits: ['input', 'update:modelValue'],

    name: 'ChatMessage',

    components: {
        ChatMessageUploadOpen,
    },

    props: {
        myUser: Object,
        modelValue: Object,
        showTime: Boolean,
        showUser: Boolean,
        right: Boolean,
    },

    computed: {
        message: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },

        // aguardando moderação: só o próprio autor recebe a mensagem neste estado
        pending() {
            return Number(this.message.status) === 0;
        },

        align() {
            return this.message.user.id == this.myUser.id
                ? 'text-right fl-right'
                : 'text-left fl-left';
        },

        alignMessage() {
            return this.message.user.id == this.myUser.id
                ? 'text-right'
                : 'text-left fl-left';
        },

        userType() {
            return this.message.user.id == this.myUser.id
                ? 'chat_msg_item_user'
                : 'chat_msg_item_admin';
        },
    },

};
</script>

<style scoped>
    .avatar {
        width: 26px;
        height: 26px;
        margin-top: 5px;
    }
    .fl-right {
        margin-right: 15px;
        float: right;
    }
    .fl-left {
        margin-left: 15px;
        float: left;
    }
    .chat_msg_avatar {
        clear: both;
    }

    .chat_msg_avatar .chat_msg_item {
        max-width: 80%;
        word-break: break-word;
        clear: unset;
    }
    .text-right {
        text-align: right;
        margin-right: 15px;
    }
    .text-left {
        text-align: left;
        margin-left: 15px;
    }
    .chat_msg_item {
        position: relative;
        margin: 2px 0 8px 0;
        padding: 8px 10px;
        max-width: 80%;
        display: block;
        word-wrap: break-word;
        word-break: break-word;
        border-radius: 3px;
        -webkit-animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
        animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
        clear: both;
        z-index: 999;
    }

    .chat_msg_item_pending {
        opacity: 0.6;
        border: 1px dashed currentColor;
    }
    .chat_msg_pending_label {
        display: block;
        margin-top: 4px;
        font-style: italic;
    }

    .status {
        clear: both;
        font-size: 14px;
        opacity: 0.3;
    }

    .chat_msg_item .chat_avatar {
        position: absolute;
        top: 0;
    }

    .chat_msg_item.chat_msg_item_admin .chat_avatar {
        left: -52px;
        background: rgba(0, 0, 0, 0.03);
    }

    .chat_msg_item.chat_msg_item_user .chat_avatar {
        right: -52px;
        background: rgba(0, 0, 0, 0.6);
    }

    .chat_msg_item .chat_avatar,
    .chat_avatar img {
        width: 40px;
        height: 40px;
        text-align: center;
        border-radius: 50%;
    }

    .chat_msg_item.chat_msg_item_admin {
        margin-left: 15px;
        float: left;
        background: rgba(0, 0, 0, 0.25);
        color: #000;
    }

    .chat_msg_item.chat_msg_item_user {
        margin-right: 15px;
        float: right;
        background: rgb(94, 114, 228);
        color: #fff;
    }

    .chat_msg_item.chat_msg_item_admin:before {
        content: "";
        position: absolute;
        top: 15px;
        left: -12px;
        z-index: 998;
        border: 6px solid transparent;
        border-right-color: rgba(255, 255, 255, 0.1);
    }

    .chat_form .get-notified label {
        color: #077ad6;
        font-weight: 600;
        font-size: 14px;
    }
</style>
